import styled from 'styled-components';

const CreateInputBox = styled.div`
    display: flex;
    align-items: center;
    height: 40px;
    width: 100%;
`;

export default CreateInputBox;